var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        { staticStyle: { width: "808px" }, attrs: { form: _vm.form } },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("兑奖设置")]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "bg",
                class: {
                  bgEwm: _vm.cashingMethod === 1,
                  bgInfo: _vm.cashingMethod === 2,
                },
                style: {
                  backgroundImage:
                    "url(" + _vm.api.temp.FILE_PATH + _vm.cashingImg + ")",
                },
              },
              [
                _vm.cashingMethod === 1
                  ? _c("div", { staticClass: "ewm" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/ewm.jpg"),
                          alt: "",
                        },
                      }),
                      _c("p", [_vm._v("添加客服领取奖品吧!")]),
                    ])
                  : _vm._e(),
                _vm.cashingMethod === 2
                  ? _c(
                      "div",
                      { staticClass: "info" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            style: { color: _vm.cashingFontColor },
                          },
                          [_c("span", [_vm._v("* ")]), _vm._v("姓名：")]
                        ),
                        _c("a-input", {
                          style: {
                            backgroundColor: _vm.cashingInputColor + "80",
                            color: _vm.cashingFontColor,
                          },
                          attrs: {
                            type: "text",
                            value: "请输入姓名",
                            disabled: true,
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            style: { color: _vm.cashingFontColor },
                          },
                          [_c("span", [_vm._v("* ")]), _vm._v("联系方式：")]
                        ),
                        _c("a-input", {
                          style: {
                            backgroundColor: _vm.cashingInputColor + "80",
                            color: _vm.cashingFontColor,
                          },
                          attrs: {
                            type: "text",
                            value: "请输入手机号码",
                            disabled: true,
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            style: { color: _vm.cashingFontColor },
                          },
                          [_c("span", [_vm._v("* ")]), _vm._v("联系地址：")]
                        ),
                        _c("a-textarea", {
                          style: {
                            backgroundColor: _vm.cashingInputColor + "80",
                            color: _vm.cashingFontColor,
                          },
                          attrs: {
                            type: "text",
                            value: "请输入联系地址",
                            disabled: true,
                          },
                        }),
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c("button", { attrs: { disabled: "" } }, [
                            _vm._v("提交"),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { staticClass: "form" },
              [
                _c("div", { staticClass: "form_title" }, [_vm._v("兑奖方式")]),
                _c(
                  "a-radio-group",
                  {
                    model: {
                      value: _vm.cashingMethod,
                      callback: function ($$v) {
                        _vm.cashingMethod = $$v
                      },
                      expression: "cashingMethod",
                    },
                  },
                  [
                    _c(
                      "a-radio",
                      { attrs: { value: 1 } },
                      [
                        _vm._v(" 添加员工兑奖 "),
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "兑奖员工",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 8 },
                            },
                          },
                          [
                            _c("picker", {
                              ref: "companyUserPicker",
                              attrs: {
                                text: _vm.cashingUserName,
                                title: "选择相关人员",
                              },
                              on: { select: _vm.selectPicker },
                              scopedSlots: _vm._u([
                                {
                                  key: "childTable",
                                  fn: function () {
                                    return [
                                      _c("employeeTable", {
                                        ref: "employeeTable",
                                        on: { getTableData: _vm.getTableData },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.cashingUserId,
                                callback: function ($$v) {
                                  _vm.cashingUserId = $$v
                                },
                                expression: "cashingUserId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", [
                          _vm._v("建议关闭员工的添加验证"),
                          _c("br"),
                          _vm._v("设置路径：企业微信APP设置>隐私"),
                        ]),
                      ],
                      1
                    ),
                    _c("a-radio", { attrs: { value: 2 } }, [
                      _vm._v(" 填写表单兑奖 "),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("span", [_vm._v("*")]),
                          _vm._v(" 上传海报背景图 "),
                          _c("uploader", {
                            attrs: {
                              num: 1,
                              accept: "image/*",
                              url: _vm.api.temp.UPLOAD_PATH,
                            },
                            model: {
                              value: _vm.cashingImg,
                              callback: function ($$v) {
                                _vm.cashingImg = $$v
                              },
                              expression: "cashingImg",
                            },
                          }),
                          _vm._v(
                            " 只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，"
                          ),
                          _c("br"),
                          _vm._v("不超过5M "),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("span", [_vm._v("*")]),
                          _vm._v(" 字体颜色 "),
                          _c("colorPicker", {
                            staticStyle: { border: "1px solid #000" },
                            model: {
                              value: _vm.cashingFontColor,
                              callback: function ($$v) {
                                _vm.cashingFontColor = $$v
                              },
                              expression: "cashingFontColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("span", [_vm._v("*")]),
                          _vm._v(" 输入框背景色 "),
                          _c("colorPicker", {
                            staticStyle: { border: "1px solid #000" },
                            model: {
                              value: _vm.cashingInputColor,
                              callback: function ($$v) {
                                _vm.cashingInputColor = $$v
                              },
                              expression: "cashingInputColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.lastStep } }, [_vm._v("上一步")]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }